<section id="wrapper" class="container wrapper-top content-wrapper">

    <article>
        <div class="row">
            <div class="col-xs-9">
                <h3>Meine bisherigen Foto-Referenzen:</h3>
                <ul class="ref-list">
                    <li>Kandahar Weltcup Garmisch-Partenkirchen 2019/2020</li>
                    <li>Bildzeitung München</li>
                    <li>Münchner Sommernachtstraum</li>
                    <li>Holi Fest München</li>
                    <li>Redbul Crashed Ice</li>
                    <li>News5</li>
                    <li>usw...</li>
                </ul>
            </div>
        </div>
    </article>
</section>
